'use strict';
import { addBrowserClasses, isMobile, debounce, setHeaderHeight } from './modules/_utils';
import './nav/nav.js';
import './modules/banner-trends.js';
import { deepLink } from "./modules/_deeplink";

new deepLink();

document.addEventListener('DOMContentLoaded', function() {

    document.getElementsByClassName('no-js')[0].classList.remove('no-js');

    // Common functions
    addBrowserClasses();

    isMobile();

    setHeaderHeight();

    

    // Hubspot cookie settings links in footer
    const hubspotCookieSettings = document.getElementById('hs-footer-cookie-settings');
    if (hubspotCookieSettings) {
        hubspotCookieSettings.addEventListener('click', function(e) {
            e.preventDefault();
            var _hsp = window._hsp = window._hsp || [];
            _hsp.push(['showBanner']);
        });
    }


    window.addEventListener('resize', setHeaderHeight);

 

    /**
     *
     *
     * Resize Timer
     *
     *
     */

    // Stop any animation/transition while window is being resized
    let resizeTimer;
    window.addEventListener("resize", () => {
        document.body.classList.add("resize-animation-stopper");
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove("resize-animation-stopper");
        }, 400);
    });





    /**
     *
     *
     * Staffing Request
     *
     *
     */


    const staffingOptions = document.querySelector('.staffing-options');
    // const staffingContent = document.querySelector('.staffing-content');

    const clinicalOpt = document.querySelector('.clinical-option');
    const nonClinicalOpt = document.querySelector('.non-clinical-option');
    const locumsOpt = document.querySelector('.locums-option');

    const clinical = document.querySelector('.clinical');
    const nonClinical = document.querySelector('.non-clinical');
    const locums = document.querySelector('.locums');


    if (staffingOptions) {

        clinicalOpt.addEventListener('click', function(e) {
            e.preventDefault();

            for (let sibling of this.parentNode.children) {
                sibling.classList.remove('active');
            }

            this.classList.add('active');

            clinical.classList.add('active');
            nonClinical.classList.remove('active');
            locums.classList.remove('active');
        });
        nonClinicalOpt.addEventListener('click', function(e) {
            e.preventDefault();

            for (let sibling of this.parentNode.children) {
                sibling.classList.remove('active');
            }

            this.classList.add('active');

            nonClinical.classList.add('active');
            clinical.classList.remove('active');
            locums.classList.remove('active');
        });
        locumsOpt.addEventListener('click', function(e) {
            e.preventDefault();

            for (let sibling of this.parentNode.children) {
                sibling.classList.remove('active');
            }

            this.classList.add('active');

            locums.classList.add('active');
            nonClinical.classList.remove('active');
            clinical.classList.remove('active');
        });



    }




    /**
     *
     *
     * Animated number counter on scroll
     *
     *
     */

    const counters = document.querySelectorAll('.num'),
        speed = 200,

        observer = new IntersectionObserver(
            entries => entries.forEach(entry => entry.isIntersecting && animate(entry.target)),
            {
                threshold: 1
            }
        ),
        // the animate function now accepts a counter (HTML element)
        animate = counter => {
            const value = +counter.dataset.value,
                data = +counter.innerText,
                time = value / speed;
            if (data < value) {
                counter.innerText = Math.ceil(data + time);
                setTimeout(() => animate(counter), 1);
            } else {
                counter.innerText = value.toLocaleString();
            }
        };

    // attach the counters to the observer
    counters.forEach(c => observer.observe(c));




    /**
     *
     *
     * Modal
     *
     *
     */


    // Get all buttons with a 'data-target' attribute
    const openBtns = document.querySelectorAll('[data-target]');

    // Get all buttons with a 'data-close' attribute
    const closeBtns = document.querySelectorAll('[data-close]');

    // Function to open a specific modal
    function openModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.classList.add('is-visible');
        }
    }

    // Function to close a specific modal
    function closeModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            modal.classList.remove('is-visible');

            // Find and stop the HTML5 video
            // const html5Video = modal.querySelector('video');
            // if (html5Video) {
            //   html5Video.pause();
            // }

            // Find and stop the YouTube video
            const youtubeIframe = modal.querySelector('iframe');
            if (youtubeIframe) {
                // This reloads the iframe to stop the video
                const iframeSrc = youtubeIframe.src;
                youtubeIframe.src = iframeSrc;
            }
        }

    }

    // Add a click event listener to each open button
    openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const modalId = btn.getAttribute('data-target');
            deepLink.create(btn);
            openModal(modalId);
        });
    });

    // Inject a share button into every video modal
    document.querySelectorAll('.modal .modal-content').forEach(content => {
        const embed = content.querySelector('.embed-container');
        if (!embed) return;

        const share = document.createElement('button');
        share.type = 'button';
        share.className = 'share';
        share.setAttribute('aria-label', 'Copy shareable link');
        share.innerHTML = `<span class="share-label">Share</span>`;
        content.insertBefore(share, embed);

        const label = share.querySelector('.share-label');
        let resetTimer;
        share.addEventListener('click', async () => {
            await navigator.clipboard.writeText(window.location.href);
            share.classList.add('copied');
            label.textContent = 'Copied!';
            clearTimeout(resetTimer);
            resetTimer = setTimeout(() => {
                share.classList.remove('copied');
                label.textContent = 'Share';
            }, 2000);
        });
    });

    // Add a click event listener to each close button
    closeBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const modalId = btn.getAttribute('data-close');
            closeModal(modalId);
            deepLink.remove('video');
        });
    });

    // Close the modal when the user clicks outside of it
    window.addEventListener('click', (event) => {
        if (event.target.classList.contains('modal')) {
            closeModal(event.target.id);
            deepLink.remove('video');
        }
    });


    // Open modal if ?video=xxxx
    deepLink.openDeepLink('video');


    /**
     *
     *
     * Marquee
     *
     *
     */


    function calculateMarqueeWidth() {
        const marqueeImages = document.querySelector('.marquee-images');
        const marqueeContent = document.querySelector('.marquee-content');

        // Check if marquee exists to prevent errors
        if (!marqueeImages || !marqueeContent) {
            // console.error('Marquee element not found.');
            return;
        }

        // The total width of the first set of content
        const totalWidth = marqueeContent.getBoundingClientRect().width;
        // Set the CSS variable for the animation
        marqueeImages.style.setProperty('--marquee-width', `-${totalWidth}px`);
    }

    calculateMarqueeWidth();

    const marqueeContent = document.querySelector('.marquee-content');

    if (marqueeContent) {
        // Start observing the .marquee-content element
        const resizeObserver = new ResizeObserver(() => {
            calculateMarqueeWidth();
        });
        resizeObserver.observe(marqueeContent);
    }



    const formItems = document.querySelectorAll('.hsfc-Step__Content .hsfc-Row');
    if (formItems.length >= 8) {
        const parent = formItems[5].parentNode;
        const wrapper = document.createElement('div');
        wrapper.classList.add('wrapper');
        // Move the 6th, 7th, and 8th elements into the wrapper
        for (let i = 5; i <= 7; i++) {
            wrapper.appendChild(formItems[i]);
        }
        // Insert the wrapper at the position of the 6th element
        parent.insertBefore(wrapper, formItems[5] || null);
    }




});
